import styles from '../../pages/Attendant/AttendantPage.module.scss';
import './module.scss';
import { Dialog, DialogProps } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { FC, PropsWithChildren, ReactNode } from 'react';

interface ModalProps extends DialogProps {
    children: ReactNode;
    withStyle?: boolean;
}

export const LegacyModal = ({
    children,
    resizable = false,
    draggable = false,
    closeOnEscape = false,
    footer = null,
    blockScroll = true,
    className,
    withStyle = true,
    ...rest
}: ModalProps) => {
    return (
        <Dialog
            closeOnEscape={closeOnEscape}
            resizable={resizable}
            draggable={draggable}
            footer={footer}
            blockScroll={blockScroll}
            className={classNames('legacy-dialog', className, {
                [styles.modal]: withStyle,
            })}
            {...rest}
        >
            {children}
        </Dialog>
    );
};

export type ApplicationModalProps = PropsWithChildren<{
    isOpen?: boolean;
    onClose?: () => void;

    header?: ReactNode;

    // Legacy TODO: Rewrite to controller
    closable?: boolean;

    /** Destroy component on close (when isOpen = false)
     * @default false
     */
    destroyOnClose?: boolean;
}>;

export const ApplicationModal: FC<ApplicationModalProps> = (
    props: ApplicationModalProps
) => {
    const {
        onClose,
        isOpen = false,
        closable = true,
        header = null,
        destroyOnClose = false,
    } = props;

    const onHide: VoidFunction = () => {
        if (onClose) onClose();
    };

    if (destroyOnClose && !isOpen) return null;

    return (
        <Dialog
            focusOnShow={false}
            className={classNames('application-modal')}
            baseZIndex={2}
            header={header}
            visible={isOpen}
            onHide={onHide}
            closable={closable}
            resizable={false}
            draggable={false}
        >
            {props.children}
        </Dialog>
    );
};
